<div class="card flex justify-content-start ml-2 pl-1">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbItems">
      <ng-template pTemplate="item" let-item>
          <i class="pi pi-reply" style="color: #6e6e6e; margin-right: 0.5rem" *ngIf="item.index === 0" ></i>
          <ng-container *ngIf="item.route; else elseBlock">
              <a [routerLink]="item.route" class="p-menuitem-link">
                  <span [ngClass]="[item.icon ? item.icon : '', 'text-color']"></span>
                  <span class="text-sm c-link" [ngClass]="isCurrentRoute(item.route) ? 'active-link' : 'unactive-link'">{{ item.label }}</span>
              </a>
          </ng-container>
          <ng-template #elseBlock>
              <a [href]="item.url">
                  <span class="text-color">{{ item.label }}</span>
              </a>
          </ng-template>
      </ng-template>
  </p-breadcrumb>
</div>
